import React from "react"
import { Link, useI18next, useTranslation } from "gatsby-plugin-react-i18next"
import { Container } from "src/components/common"
import { track } from "src/utils/track"
import { contact, social } from "src/data/config"
import logo from "src/assets/images/logo-medienkram-black.png"
import linkedin from "src/assets/icons/linkedin-rounded.svg"
import xing from "src/assets/icons/xing-rounded.svg"
import { Wrapper, Grid, Column, Brand, Social, Legal } from "./styles"

export const Footer = () => {
  const { t } = useTranslation()
  const { language, defaultLanguage } = useI18next()
  const prefix = language !== defaultLanguage ? `/${language}` : ""
  return (
    <Wrapper>
      <Container>
        <Grid>
          <Column>
            <Brand as={Link} to="/" aria-label={t("back_home")}>
              <img src={logo} width="154" height="25" alt="medienkram" />
            </Brand>
            <p>{t("footer_claim")}</p>
          </Column>
          <Column>
            <h2>{t("footer_contact")}</h2>
            <ul>
              <li>
                <a
                  href={`mailto:${contact.email}`}
                  onClick={() => track("mail_click", { location: "footer" })}
                >
                  {contact.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${contact.phone}`}
                  onClick={() => track("phone_click", { location: "footer" })}
                >
                  {contact.phoneDisplay}
                </a>
              </li>
              <li>{t("contact:location")}</li>
            </ul>
          </Column>
          <Column>
            <h2>{t("footer_social")}</h2>
            <Social>
              <a
                href={social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedin} alt="" width="28" height="28" /> LinkedIn{" "}
                <span className="sr-only">({t("external_link")})</span>
              </a>
              <a href={social.xing} target="_blank" rel="noopener noreferrer">
                <img src={xing} alt="" width="28" height="28" /> Xing{" "}
                <span className="sr-only">({t("external_link")})</span>
              </a>
            </Social>
          </Column>
        </Grid>
        <Legal>
          <a href={`${prefix}/legal/`}>{t("legal")}</a>
          <a href={`${prefix}/privacy/`}>{t("privacy")}</a>
          <span>© {new Date().getFullYear()} Stefan Helker</span>
        </Legal>
      </Container>
    </Wrapper>
  )
}
